import request from '@/utils/request'
import { uuid } from 'vue-uuid';

export function getIPCompany(company_uid){
  return request({
    url: `/api/ips/company/${company_uid}`,
    method: "get"
  });
}

export function getIP(uid){
  return request({
    url: `/api/ips/${uid}`,
    method: "get"
  });
}

export function createIPCompany(company_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/ips/company/${company_uid}`,
    method: "post",
    data: data
  });
}

export function updateIP(uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/ips/${uid}`,
    method: "put",
    data: data
  });
}

export function deleteIP(uid){
  return request({
    url: `/api/ips/${uid}`,
    method: "delete",
    data: {idempotency: uuid.v1()}
  });
}
